import React from "react";
import { Navigate, Outlet } from "react-router";

const OpenLayout = ({ children }) => {
  const token = sessionStorage.getItem("token");

  if (token) {
    return <Navigate to="/home" />;
  }
  return (
    <div
      style={{
        // maxWidth: "768px",
        margin: "0 auto",
      }}
    >
      <Outlet />
    </div>
  );
};

export default OpenLayout;
